import {Observable} from "rxjs";
import {AddressCandidate} from "../model/address-candidate.model";

export abstract class AddressCandidateAdapter {

  abstract find(zipcode: string, streetNumber: string, addtion: string): Observable<AddressCandidate>;

}
